import { useState } from "react";
import "@/App.css";
import TrackerView from "@/components/TrackerView";
import ReportsView from "@/components/ReportsView";
import { Toaster } from "sonner";
import { Menu, X } from "lucide-react";

function App() {
  const [activeTab, setActiveTab] = useState("tracker");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const switchTab = (tab) => {
    setActiveTab(tab);
    setMobileMenuOpen(false);
  };

  return (
    <div className="min-h-screen bg-slate-950 relative">
      {/* Background Texture */}
      <div 
        className="fixed inset-0 pointer-events-none opacity-10 z-0"
        style={{
          backgroundImage: "url('https://static.prod-images.emergentagent.com/jobs/84aa19f3-3a4b-4c10-9d6c-540aef986ea0/images/70898b2bfd8bb7c4ca152f5a2e423250f65805583efba1dce205688f5cab3eeb.png')",
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}
      />

      {/* Navigation */}
      <nav className="sticky top-0 z-50 backdrop-blur-xl bg-slate-950/80 border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
          <div className="flex items-center justify-between">
            <h1 className="text-lg sm:text-2xl font-medium text-slate-50 truncate" style={{ fontFamily: 'var(--font-heading)' }}>
              Cheque Return Tracker
            </h1>
            
            {/* Desktop Tabs */}
            <div className="hidden sm:flex gap-2">
              <button
                data-testid="tracker-tab-btn"
                onClick={() => setActiveTab("tracker")}
                className={`px-6 py-2 rounded-sm font-medium transition-all duration-200 ${
                  activeTab === "tracker"
                    ? "bg-white text-slate-950"
                    : "bg-slate-900 text-slate-400 hover:bg-slate-800 hover:text-white"
                }`}
              >
                Tracker
              </button>
              <button
                data-testid="reports-tab-btn"
                onClick={() => setActiveTab("reports")}
                className={`px-6 py-2 rounded-sm font-medium transition-all duration-200 ${
                  activeTab === "reports"
                    ? "bg-white text-slate-950"
                    : "bg-slate-900 text-slate-400 hover:bg-slate-800 hover:text-white"
                }`}
              >
                Reports
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              data-testid="mobile-menu-btn"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="sm:hidden p-2 text-slate-400 hover:text-white transition-colors"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="sm:hidden mt-3 pt-3 border-t border-slate-800 flex flex-col gap-2">
              <button
                data-testid="tracker-tab-mobile-btn"
                onClick={() => switchTab("tracker")}
                className={`w-full px-4 py-3 rounded-sm font-medium transition-all duration-200 text-left ${
                  activeTab === "tracker"
                    ? "bg-white text-slate-950"
                    : "bg-slate-900 text-slate-400"
                }`}
              >
                Tracker
              </button>
              <button
                data-testid="reports-tab-mobile-btn"
                onClick={() => switchTab("reports")}
                className={`w-full px-4 py-3 rounded-sm font-medium transition-all duration-200 text-left ${
                  activeTab === "reports"
                    ? "bg-white text-slate-950"
                    : "bg-slate-900 text-slate-400"
                }`}
              >
                Reports
              </button>
            </div>
          )}
        </div>
      </nav>

      {/* Main Content */}
      <main className="relative z-10">
        {activeTab === "tracker" ? <TrackerView /> : <ReportsView />}
      </main>

      {/* Toast Notifications */}
      <Toaster position="top-right" theme="dark" />
    </div>
  );
}

export default App;